import type { rest } from 'msw';

type handlerType =
  | ReturnType<typeof rest.delete>
  | ReturnType<typeof rest.get>
  | ReturnType<typeof rest.head>
  | ReturnType<typeof rest.options>
  | ReturnType<typeof rest.patch>
  | ReturnType<typeof rest.post>
  | ReturnType<typeof rest.put>;

interface RegisterMockOptions {
  shouldStartAutomatically?: boolean;
}

interface RegisterMock {
  (mockName: string, handler: handlerType, options?: RegisterMockOptions): void;
}

interface Mock {
  mockName: string;
  handler: handlerType;
  options?: RegisterMockOptions;
}

const mocks: Mock[] = [];

export const registerMock: RegisterMock = (mockName, handler, options) => {
  mocks.push({ mockName, handler, options });
};

export const registerApiMocks = (registerFn: RegisterMock): void => {
  mocks.forEach(({ mockName, handler, options }) => {
    registerFn(mockName, handler, options);
  });
};
